module.exports = __webpack_public_path__ + "img/gptw_background.18f55149.jpg";